import React from "react";
import {
  Avatar,
  ChecklistDropdown,
  FilterLabelButton,
} from "@toddle-edu/ds-web";
import { getLabelValueForDropdown } from "modules/Services";

import classes from "./SchoolTemplateFilters.scss";
import { useI18n } from "Hooks";

const SchoolTemplateFilters = ({ staffList, createdBy, setCreatedBy }) => {
  const { t } = useI18n();

  const renderCreatorFilters = () => (
    <ChecklistDropdown
      dsVersion={"2.0"}
      options={staffList}
      showAllOption={true}
      value={createdBy}
      onChange={setCreatedBy}
      allOptionPrefix={
        <Avatar
          dsVersion={"2.0"}
          size={"x-small"}
          iconType={"group"}
          color={"neutral"}
          shade={"light"}
        />
      }
      hasAvatar
      isMatchingTextEnabled
      isSearchEnabled
    >
      <FilterLabelButton
        dsVersion={"2.0"}
        type={"plain"}
        variant="neutral"
        label={t("common:creator")}
        labelValue={getLabelValueForDropdown({
          selectedItems: createdBy,
          itemList: staffList,
          t,
          noneSelectedText: t("common:all"),
        })}
      />
    </ChecklistDropdown>
  );
  return (
    <div className={classes.filtersConatiner}>{renderCreatorFilters()}</div>
  );
};

export default SchoolTemplateFilters;
